export const moduleConfig = {
    entityKey: 'productLineItems',
    titles: {
        singular: 'Product Line Item',
        plural: 'Product Line Items'
    }
}

export const initialSortState = {
    column: 'position',
    direction: 'asc',
};